export default "__VITE_ASSET__c6f9fbe6__"